"use client";
// Imports
import { cva } from "class-variance-authority";

const defaultPadding = "py-3 lg:py-6";

// Styles
const ComponentWrapperStyles = cva("", {
  variants: {
    type: {
      default: defaultPadding,
      card_grid: defaultPadding,
      row_grid: defaultPadding,
      hero_video: "lg:pb-6 w-full",
      hero_slideshow: "w-full",
      tiles: defaultPadding,
      featured_tiles: "",
      stats_band: "",
      divider: "",
      featured_stories: "",
      instructions: "",
      text_content: defaultPadding,
      text_with_image: defaultPadding,
      floating_image_with_text: defaultPadding,
      video: defaultPadding,
      image: defaultPadding,
      rolling_carousel: "py-6 lg:py-24",
      horizontal_advertisement: defaultPadding,
      vertical_advertisement: "w-full",
      events_grid: defaultPadding,
      filtered_events_grid: defaultPadding,
      whats_on: "bg-brand-wool " + defaultPadding,
      subscribe: "relative",
      iframe_embed: `${defaultPadding}`,
      slideshow: `${defaultPadding} h-full`,
      code: `${defaultPadding} h-20 bg-black`,
    },
  },
  defaultVariants: {
    type: "default",
  },
});

// CSS enter animation — Framer initial opacity:0 can stick under React 19
export function ComponentWrapper({ children, type, className = "" }) {
  return (
    <div
      data-type="page-builder-component"
      data-name={type}
      className={`animate-section-in ${ComponentWrapperStyles({ type })} ${className}`}
    >
      {children}
    </div>
  );
}
